app.config(['$locationProvider', '$stateProvider', function ($locationProvider, $stateProvider) {
    $locationProvider.html5Mode(true);
    $locationProvider.hashPrefix('!');
        $stateProvider
            .state('home',
                {
                    url: '/',
                    templateUrl: '/ng-views/home/index.html?v=' + global.version,
                    controller: 'homeIndexCtrl',
                    resolve: {                        
                        'me': [
                            'authService', function (authService) {
                                return authService.me();
                            }
                        ]
                    },
                    ncyBreadcrumb: {
                        label: 'Hjem'
                    }
                })
            .state('exercises',
                {
                    url: '/exercises',
                    templateUrl: '/ng-views/exercises/index.html?v=' + global.version,
                    controller: 'exercisesIndexCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Opgaver'
                    }
                })
            .state('exercises.add',
            {
                url: '/add',
                templateUrl: '/ng-views/exercises/add.html?v=' + global.version,
                controller: 'exercisesAddCtrl as vm',
                ncyBreadcrumb: {
                    label: 'Tilføj opgave'
                    }
            })
            .state('exercises.details',
            {
                url: '/details/{id}',
                templateUrl: '/ng-views/exercises/add.html?v=' + global.version,
                controller: 'exercisesAddCtrl as vm',
                ncyBreadcrumb: {
                    label: '{{exercise.name}}'
                }
            })
            .state('config',
                {
                    url: '/config',
                    templateUrl: '/ng-views/config/index.html?v=' + global.version,
                    controller: 'configIndexCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Config'
                    }
                })
            .state('testticket',
                {
                    url: '/testticket',
                    templateUrl: '/ng-views/testticket/index.html?v=' + global.version,
                    controller: 'testTicketIndexCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Test-billeter'
                    }
                })
            .state('rides',
                {
                    url: '/rides',
                    templateUrl: '/ng-views/rides/index.html?v=' + global.version,
                    controller: 'ridesIndexCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Forlystelser'
                    }
                })
                .state('rides.add',
                {
                    url: '/add',
                    templateUrl: '/ng-views/rides/add.html?v=' + global.version,
                    controller: 'ridesAddCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Tilføj forlystelse'
                    }
                })
                .state('rides.details',
                {
                    url: '/details/{id}',
                    templateUrl: '/ng-views/rides/add.html?v=' + global.version,
                    controller: 'ridesAddCtrl as vm',
                    ncyBreadcrumb: {
                        label: '{{ride.name}}'
                    }
                })
            .state('stats',
            {
                url: '/stats',
                templateUrl: '/ng-views/stats/index.html?v=' + global.version,
                controller: 'statsIndexCtrl as vm',
                ncyBreadcrumb: {
                    label: 'Statistik'
                }
            })
            .state('freegame',
            {
                url: '/freegame',
                templateUrl: '/ng-views/freegame/index.html?v=' + global.version,
                controller: 'freeGameIndexCtrl as vm',
                ncyBreadcrumb: {
                    label: 'Den åbne opgave'
                }
            })
            .state('administration',
                {
                    url: '/administration',
                    templateUrl: '/ng-views/administration/index.html?v=' + global.version,
                    controller: 'administrationIndexCtrl',
                    ncyBreadcrumb: {
                        label: 'Administration'
                    }
                })
            .state('teacher',
                {
                    url: '/teacher',
                    redirectTo: 'teacher.signup',
                    templateUrl: '/ng-views/teacher/index.html?v=' + global.version,
                    ncyBreadcrumb: {
                        label: 'Lærer'
                    },

                })
            .state('teacher.login',
                {
                    url: '/login',
                    templateUrl: '/ng-views/teacher/login/index.html?=v' + global.version,
                    controller: 'teacherLoginCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Login'
                    }
                })
            .state('teacher.signup',
                {
                    url: '/welcome',
                    templateUrl: '/ng-views/teacher/signup/index.html?v=' + global.version,
                    controller: 'teacherSignupCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Velkommen til Faglige Dage'
                    }
                })
            .state('teacher.setupexercises',
                {
                    url: '/setupexercises',
                    templateUrl: '/ng-views/teacher/setupexercises/index.html?v=' + global.version,
                    controller: 'teacherSetupExercisesCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Vælg opgaver'
                    }
                })
            .state('teacher.setupgroups',
                {
                    url: '/setupgroups',
                    templateUrl: '/ng-views/teacher/setupgroups/index.html?v=' + global.version,
                    controller: 'teacherSetupGroupsCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Opret grupper'
                    }
                })
            .state('teacher.groupdetails',
                {
                    url: '/groupdetails/:id',
                    templateUrl: '/ng-views/teacher/groupdetails/index.html?v=' + global.version,
                    controller: 'teacherGroupDetailsCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Redigér gruppe'
                    }
                })
            .state('teacher.groups',
                {
                    url: '/groups',
                    templateUrl: '/ng-views/teacher/groups/index.html?v=' + global.version,
                    controller: 'teacherGroupsCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Gruppeoversigt'
                    }
                })
            .state('teacher.evaluation',
                {
                    url: '/evaluation',
                    templateUrl: '/ng-views/teacher/evaluation/index.html?v=' + global.version,
                    controller: 'teacherEvaluationCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Evaluering'
                    }
                })
            .state('teacher.info',
                {
                    url: '/info',
                    templateUrl: '/ng-views/teacher/info/index.html?=v' + global.version,
                    controller: 'teacherInfoCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Vigtig info'
                    }
                })
            .state('profile',
                {
                    url: '/profile',
                    templateUrl: '/ng-views/profile/index.html?v=' + global.version,
                    resolve: {                        
                        'me': [
                            'authService', function (authService) {
                                return authService.me();
                            }
                        ]
                    },
                    controller: 'profileIndexCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Min Profil'
                    }
                })
            .state('teacherapp',
                {
                    url: '/teacherapp',
                    templateUrl: '/ng-views/teacherapp/index.html?v=' + global.version,
                    controller: 'teacherAppIndexCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'LærerApp'
                    }
                })
            .state('teacherapp.welcome',
                {
                    url: '/welcome',
                    templateUrl: '/ng-views/teacherapp/welcome/index.html?v=' + global.version,
                    controller: 'teacherAppWelcomeCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Velkommen'
                    }
                })
            .state('teacherapp.groupstatus',
                {
                    url: '/groupstatus',
                    templateUrl: '/ng-views/teacherapp/groupstatus/index.html?v=' + global.version,
                    controller: 'teacherAppGroupStatusDetailsCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Groupstatus'
                    }
                })
            .state('teacherapp.groupstatus.details',
                {
                    url: '/details/{id:int}',
                    templateUrl: '/ng-views/teacherapp/groupstatus/details.html?v=' + global.version,
                    controller: 'teacherAppGroupStatusDetailsCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Detaljer'
                    }
                })
            .state('teacherapp.groupstatus.detailsmap',
                {
                    url: '/detailsmap/{id:int}',
                    templateUrl: '/ng-views/teacherapp/groupstatus/detailsmap.html?v=' + global.version,
                    controller: 'teacherAppGroupStatusDetailsMapCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Detaljer'
                    }
                })
            .state('teacherapp.exercises',
                {
                    url: '/exercises',
                    templateUrl: '/ng-views/teacherapp/exercises/index.html?v=' + global.version,
                    controller: 'teacherAppExercisesCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Opgaveliste'
                    }
                })
            .state('teacherapp.exercisemap',
            {
                url: '/exercisemap/{id:int}',
                templateUrl: '/ng-views/teacherapp/exercisemap/index.html?v=' + global.version,
                controller: 'teacherAppExerciseMapCtrl',
                ncyBreadcrumb: {
                    label: 'OpgaveKort'
                }
            })
            .state('teacherapp.exercisebegin',
            {
                url: '/exercisebegin/{id:int}',
                templateUrl: '/ng-views/teacherapp/exercisebegin/index.html?v=' + global.version,
                controller: 'teacherAppExerciseBeginCtrl as vm',
                ncyBreadcrumb: {
                    label: 'OpgaveBegynd'
                }
            })
            .state('teacherapp.exerciseperform',
            {
                url: '/exerciseperform/{id:int}/{question:int}',
                templateUrl: '/ng-views/teacherapp/exerciseperform/index.html?v=' + global.version,
                controller: 'teacherAppExercisePerformCtrl as vm',
                ncyBreadcrumb: {
                    label: 'OpgaveDo'
                }
            })
            .state('teacherapp.exerciseevalbegin',
            {
                url: '/exerciseevalbegin/{id:int}',
                templateUrl: '/ng-views/teacherapp/exerciseevalbegin/index.html?v=' + global.version,
                controller: 'teacherAppExerciseEvalBeginCtrl as vm',
                ncyBreadcrumb: {
                    label: 'OpgaveEvalBegynd'
                }
            })
            .state('teacherapp.exerciseevalperform',
            {
                url: '/exerciseevalperform/{id:int}/{question:int}',
                templateUrl: '/ng-views/teacherapp/exerciseevalperform/index.html?v=' + global.version,
                controller: 'teacherAppExerciseEvalPerformCtrl as vm',
                ncyBreadcrumb: {
                    label: 'OpgaveEvalDo'
                }
            })
            .state('teacherapp.exercisedone',
            {
                url: '/exercisedone/{id:int}',
                templateUrl: '/ng-views/teacherapp/exercisedone/index.html?v=' + global.version,
                controller: 'teacherAppExerciseDoneCtrl as vm',
                ncyBreadcrumb: {
                    label: 'OpgaveDone'
                }
            })
            .state('teacherapp.groupmap',
                {
                    url: '/groupmap',
                    templateUrl: '/ng-views/teacherapp/groupmap/index.html?v=' + global.version,
                    controller: 'teacherAppGroupMapCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Group Map'
                    }
                })
            .state('teacherapp.messages',
                {
                    url: '/messages',
                    templateUrl: '/ng-views/teacherapp/messages/index.html?v=' + global.version,
                    controller: 'teacherAppMessagesCtrl as vm',
                    ncyBreadcrumb: {
                        label: 'Beskeder'
                    }
                })
            .state('student',
                {
                    url: '/student',
                    templateUrl: '/ng-views/student/index.html?v=' + global.version,
                    ncyBreadcrumb: {
                        label: 'Elev'
                    }
                }
            )
            .state('student.login',
            {
                url: '/login',
                templateUrl: '/ng-views/student/login/index.html?=v' + global.version,
                controller: 'studentLoginCtrl as vm',
                ncyBreadcrumb: {
                    label: 'Login'
                }
            })
            .state('student.welcome',
            {
                url: '/welcome',
                templateUrl: '/ng-views/student/carousel/index.html?v=' + global.version,
                controller: 'studentCarouselCtrl',
                ncyBreadcrumb: {
                    label: 'Velkommen'
                }
            })
            .state('student.exercises',
            {
                url: '/exercises',
                templateUrl: '/ng-views/student/exercises/index.html?v=' + global.version,
                controller: 'studentExercisesCtrl',
                ncyBreadcrumb: {
                    label: 'Velkommen'
                }
            })
            .state('student.exercisemap',
            {
                url: '/exercisemap/{id:int}',
                templateUrl: '/ng-views/student/exercisemap/index.html?v=' + global.version,
                controller: 'studentExerciseMapCtrl',
                ncyBreadcrumb: {
                    label: 'OpgaveKort'
                }
            })
            .state('student.exercisecarousel',
            {
                url: '/exercise/{id:int}',
                template: function() {
                    return '<div class="appcontent" layout="column" layout-fill>\n' +
                           '  <div class="appcarousel" layout="row">\n' + 
                           '    <div class="appcarouselcontainer" ng-include="\'/ng-views/student/exercisebegin/index.html?v=\' + global.version" ng-controller="studentExerciseBeginCtrl as vm"></div>\n' +
                           '  </div>\n' +
                           '</div>\n';
                },
                controller: 'studentCarouselCtrl',
                ncyBreadcrumb: {
                    label: 'OpgaveKarusel'
                }
            })  
            .state('student.exercisebegin',
            {
                url: '/exercisebegin/{id:int}',
                templateUrl: '/ng-views/student/exercisebegin/index.html?v=' + global.version,
                controller: 'studentExerciseBeginCtrl as vm',
                ncyBreadcrumb: {
                    label: 'OpgaveBegynd'
                }
            })
            .state('student.exerciseperform',
            {
                url: '/exerciseperform/{id:int}/{question:int}',
                templateUrl: '/ng-views/student/exerciseperform/index.html?v=' + global.version,
                controller: 'studentExercisePerformCtrl as vm',
                ncyBreadcrumb: {
                    label: 'OpgaveDo'
                }
            })
            .state('student.freegameperform',
            {
                url: '/freegameperform/{id:int}/{question:int}',
                templateUrl: '/ng-views/student/freegameperform/index.html?v=' + global.version,
                controller: 'studentFreeGamePerformCtrl as vm',
                ncyBreadcrumb: {
                    label: 'FreeGameDo'
                }
            })
            .state('student.exerciseevalbegin',
            {
                url: '/exerciseevalbegin/{id:int}',
                templateUrl: '/ng-views/student/exerciseevalbegin/index.html?v=' + global.version,
                controller: 'studentExerciseEvalBeginCtrl as vm',
                ncyBreadcrumb: {
                    label: 'OpgaveEvalBegynd'
                }
            })
            .state('student.exerciseevalperform',
            {
                url: '/exerciseevalperform/{id:int}/{question:int}',
                templateUrl: '/ng-views/student/exerciseevalperform/index.html?v=' + global.version,
                controller: 'studentExerciseEvalPerformCtrl as vm',
                ncyBreadcrumb: {
                    label: 'OpgaveEvalDo'
                }
            })
            .state('student.exercisedone',
            {
                url: '/exercisedone/{id:int}',
                templateUrl: '/ng-views/student/exercisedone/index.html?v=' + global.version,
                controller: 'studentExerciseDoneCtrl as vm',
                ncyBreadcrumb: {
                    label: 'OpgaveDone'
                }
            })
            .state('student.trophy',
            {
                url: '/trophy',
                templateUrl: '/ng-views/trophy/index.html?v=' + global.version,
                controller: 'trophyIndexCtrl',
                ncyBreadcrumb: {
                    label: 'Pokal'
                }
            })
            .state('student.worthknowing',
            {
                url: '/worthknowing',
                templateUrl: '/ng-views/student/worthknowing/index.html?v=' + global.version,
                controller: 'studentWorthKnowingIndexCtrl',
                ncyBreadcrumb: {
                    label: 'WorthKnowing'
                }
            })
            .state('student.messages',
            {
                url: '/messages',
                templateUrl: '/ng-views/student/messages/index.html?v=' + global.version,
                controller: 'studentMessagesCtrl as vm',
                ncyBreadcrumb: {
                    label: 'Beskeder'
                }
            })
            .state('preview',
                {
                    url: '/preview',
                    templateUrl: '/ng-views/preview/index.html?v=' + global.version,
                    ncyBreadcrumb: {
                        label: 'Preview'
                    }
                }
            )
            .state('preview.exercisebegin',
            {
                url: '/exercisebegin',
                templateUrl: '/ng-views/preview/exercisebegin/index.html?v=' + global.version,
                controller: 'previewExerciseBeginCtrl as vm',
                ncyBreadcrumb: {
                    label: 'OpgaveBegynd'
                }
            })
            .state('preview.exerciseperform',
            {
                url: '/exerciseperform',
                templateUrl: '/ng-views/preview/exerciseperform/index.html?v=' + global.version,
                controller: 'previewExercisePerformCtrl as vm',
                ncyBreadcrumb: {
                    label: 'OpgaveDo'
                }
            })
            .state('preview.exerciseevalbegin',
            {
                url: '/exerciseevalbegin',
                templateUrl: '/ng-views/preview/exerciseevalbegin/index.html?v=' + global.version,
                controller: 'previewExerciseEvalBeginCtrl as vm',
                ncyBreadcrumb: {
                    label: 'OpgaveEvalBegynd'
                }
            })
            .state('preview.exerciseevalperform',
            {
                url: '/exerciseevalperform',
                templateUrl: '/ng-views/preview/exerciseevalperform/index.html?v=' + global.version,
                controller: 'previewExerciseEvalPerformCtrl as vm',
                ncyBreadcrumb: {
                    label: 'OpgaveEvalDo'
                }
            })
            .state('preview.exercisedone',
            {
                url: '/exercisedone',
                templateUrl: '/ng-views/preview/exercisedone/index.html?v=' + global.version,
                controller: 'previewExerciseDoneCtrl as vm',
                ncyBreadcrumb: {
                    label: 'OpgaveDone'
                }
            })
            .state('404', {
                url: '/page-not-found',
                templateUrl: '/ng-views/shared/404.html?v=' + global.version,
                controller: 'notFoundCtrl'
            })
            .state('500', {
                url: '/an-error-occured',
                templateUrl: '/ng-views/shared/500.html?v=' + global.version,
                controller: 'errorCtrl'
            });
}]);
